import api from './client';

export interface ReceiptItemIn {
  warehouse_item_id: number;
  quantity: number;
  price_per_unit: number;
}

export interface ReceiptItem {
  id: number;
  warehouse_item_id: number;
  warehouse_item: { id: number; name: string; unit: string };
  quantity: number;
  price_per_unit: number;
}

export interface WarehouseReceipt {
  id: number;
  date: string;
  supplier: string | null;
  notes: string | null;
  receipt_photo_url: string | null;
  items: ReceiptItem[];
}

export const getReceipts = () =>
  api.get<WarehouseReceipt[]>('/warehouse-receipts').then(r => r.data);

export const createReceipt = (data: {
  date: string;
  supplier?: string;
  notes?: string;
  items: ReceiptItemIn[];
}) => api.post<WarehouseReceipt>('/warehouse-receipts', data).then(r => r.data);

export const deleteReceipt = (id: number) =>
  api.delete(`/warehouse-receipts/${id}`);
